import clsx from 'clsx';

import UserThumbnail from '@atom/components/common/UserThumbnail';
import { Checkbox } from '@atom/mui';
import { UserDetail } from '@atom/types/user';

import classes from './teamControls.module.css';

interface Props {
  user: UserDetail;
  selectedUsers: Set<string>;
  toggleUser: (id: string) => void;
  groupId: string;
}

const AddUserRow = ({ user, toggleUser, selectedUsers, groupId }: Props) => {
  const userGroups = user.userGroups.map(userGroup => userGroup.id);

  const isPending = !user.isActive && !user.isVerified;
  const isDisabled = userGroups.includes(groupId);
  const isChecked = selectedUsers.has(user.id);

  const onToggle = isDisabled ? () => {} : () => toggleUser(user.id);

  const getUserLabel = () => {
    if (isPending) {
      return 'Pending Request';
    }

    if (isDisabled) {
      return 'Already in this group';
    }

    return '';
  };

  return (
    <div className={classes.userRow}>
      <div className={classes.usersLeftContent}>
        <div>
          <Checkbox onChange={onToggle} checked={isChecked} />
        </div>
        <UserThumbnail
          image={user.photoUrl}
          alt={user.firstName}
          pending={isPending}
        />
        <div className={classes.infoContainer} onClick={onToggle}>
          <div
            className={clsx(classes.userName, isDisabled && classes.disabled)}
          >{`${user.firstName} ${user.lastName}`}</div>
          <div
            className={clsx(classes.userEmail, isDisabled && classes.disabled)}
          >
            {user.email}
          </div>
        </div>
      </div>
      <div className={classes.userLabel}>{getUserLabel()}</div>
    </div>
  );
};

export default AddUserRow;
